import ApiRequest from "../utils/apiRequest"

export default class Booth {
    static login = async (body) => {
        return await ApiRequest.set("v1/booth/login", "POST", body)
    }

    static loginShort = async (body) => {
        return await ApiRequest.set("v1/booth/loginshort", "POST", body)
    }

    static getAll = async () => {
        return await ApiRequest.set("v1/booths", "GET")
    }

    static getById = async (id) => {
        return await ApiRequest.set("v1/booth/"+id, "GET")
    }

    static create = async (body) => {
        return await ApiRequest.set("v1/booth", "POST", body)
    }

    static edit = async (id, body) => {
        return await ApiRequest.set("v1/booth/"+id, "PUT", body)
    }
    static password_reset = async (id, body) => {
        return await ApiRequest.set("v1/booth/"+id + "/password_reset", "PATCH", body)
    }

    static delete = async (id) => {
        return await ApiRequest.set("v1/booth/"+id, "DELETE")
    }

    static restore = async (id) => {
        return await ApiRequest.set("v1/booth/"+id, "PATCH")
    }
}